import React from 'react';
import { FiMapPin, FiMail, FiPhone, FiClock } from 'react-icons/fi';
import { FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';
import ContactForm from '../forms/ContactForm';
import { Helmet } from 'react-helmet';
import { CiInstagram } from 'react-icons/ci';

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact PG Overseas Services | Global Business Support & Consulting</title>
        <meta
          name="description"
          content="Get in touch with PG Overseas Services for expert guidance on migration, business expansion, real estate, and international consulting. Reach us via form, phone, or email."
        />
        <meta
          name="keywords"
          content="contact PG Overseas Services, global consulting contact, migration help India, business expansion support, overseas services Gujarat, contact relocation experts"
        />
      </Helmet>

      <section className="bg-bgpalecolor from-gray-100 to-white py-20 mt-10 font-basefont">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-basecolor mb-4">Connect With Us</h2>
            <p className="text-lg text-gray-600">We're here to help. Reach out through the form or our contact details below.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {/* Contact Form - Larger Column */}
            <div className="md:col-span-2 rounded-lg bg-white shadow-md  p-8 sm:p-10">
              <ContactForm />
            </div>

            {/* Contact Information */}
            <div className="rounded-lg shadow-lg bg-white p-8 sm:p-10">
              <h3 className="text-xl font-semibold text-basecolor mb-6">Contact Details</h3>
              <div className="space-y-6">
                <div className="flex items-start text-gray-700">
                  <FiMapPin className="w-6 h-6 mr-4 text-basecolor flex-shrink-0" />
                  <div>
                    <h6 className="font-semibold">India</h6>
                    <p className="leading-relaxed">Mumbai</p>
                    <p className="leading-relaxed">Ahmedabad</p>
                    <p className="leading-relaxed">Rajkot</p>
                  </div>
                </div>
                <div className="flex items-start text-gray-700">
                  <FiPhone className="w-6 h-6 mr-4 text-basecolor flex-shrink-0" />
                  <div>
                    <h6 className="font-semibold">Phone:</h6>
                    <a href="tel:+919925000431" className="leading-relaxed hover:underline">
                      +91 9925000431
                    </a>
                  </div>
                </div>
                {/* <div className="flex items-start text-gray-700">
                  <FiMail className="w-6 h-6 mr-4 text-basecolor flex-shrink-0" />
                  <div>
                    <h6 className="font-semibold">Email:</h6>
                    <a href="mailto:info@pgoverseasservices.com" className="leading-relaxed hover:underline">
                      info@pgoverseasservices.com
                    </a>
                  </div>
                </div> */}
                <div className="flex items-start text-gray-700">
                  <FiClock className="w-6 h-6 mr-4 text-basecolor flex-shrink-0" />
                  <div>
                    <h6 className="font-semibold">Hours of Operation (IST):</h6>
                    <p className="leading-relaxed">Monday to Friday, 9:00 AM to 6:00 PM</p>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <h3 className="text-xl font-semibold text-basecolor mb-4">Global Presence</h3>
                <div>

                  <ul className="list-disc list-inside text-gray-600">
                    <li>Australia</li>
                    <li>New Zealand</li>
                    <li>Indonesia</li>
                    <li>United Kingdom</li>
                    <li>UAE</li>

                  </ul>
                </div>
              </div>

              <div className="mt-8">
                <h3 className="text-xl font-semibold text-basecolor mb-4">Follow Us</h3>
                <div className="flex space-x-4 text-gray-500">
                  <a href="https://www.instagram.com/pgoverseasservices/profilecard/?igsh=MTlycDNwaTg5eTd4aw==" target="_blank" rel="noopener noreferrer" className="hover:text-basecolor transition-colors">
                    <CiInstagram className="hover:text-lightcolor w-6 h-6" />
                  </a>

                  <a href="https://www.linkedin.com/company/pg-overseas-services/about/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="hover:text-basecolor transition-colors">
                    <FaLinkedin className="w-6 h-6" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>

  );
};

export default Contact;